<template>
  <div class="wf-variables-table-banner">
    <div v-if="showIcon" class="icon-wrapper">
      <WfIcon icon="warning-outline" :color="color" />
    </div>
    <div class="message">{{ message }}</div>
    <div class="icon-wrapper" @click="$emit('close')">
      <WfIcon icon="times" />
    </div>
  </div>
</template>

<script setup>
import WfIcon from '@/components/WfIcon.vue';

defineProps({
  message: {
    type: String,
    required: true,
  },
  color: {
    type: String,
    default: '#D7A220',
  },
  showIcon: {
    type: Boolean,
    default: false,
  },
});

defineEmits(['close']);
</script>
